import React, { useEffect } from "react";
import "./Period.css";


import Mockup1 from "../../assets/Period_VK.png";

function useScrollReveal() {
  useEffect(() => {
    const elements = document.querySelectorAll(".period .reveal");
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);
}

export default function Period() {
  useScrollReveal();

  return (
    <main className="project-page period">
      {/* ================= HERO ================= */}
      <section className="hero reveal">
        <div className="hero-copy">
          <p className="hero-kicker">Personal project · Period</p>

          <h1 className="hero-title">
            Period Project
            <span className="hero-title-accent">{" "}Social Initiative</span>
          </h1>

          <p className="hero-body">
          Together with a friend, I started an initiative to introduce free menstrual
          products at Umeå University. The goal was to reduce stigma and improve
          accessibility for students.
          <br /><br />
          We contacted companies to seek sponsorship, where partners would support the
          project and in return receive a diploma recognizing their commitment to
          women's health and equality.
          </p>

          <div className="hero-tags">
            <span>Social Impact</span>
            <span>Entrepreneurship</span>
            <span>Project Management</span>
          </div>
        </div>

        <div className="hero-image">
          <div className="hero-mockup-frame">
            <img src={Mockup1} alt="Period mockup" />
          </div>
        </div>
      </section>

      {/* ================= PROJECT OVERVIEW ================= */}
      <section className="project-section reveal">
        <h2>Project Overview</h2>
        <p className="large-text">
        This project was initiated by me and a friend with the goal of introducing free menstrual products at Umeå University.<br></br>

        <br></br>We contacted companies to seek sponsorship, where the sponsors would contribute products or funding. In return, they would receive a diploma recognizing their support for gender equality and women's health. <br></br>

        <br></br>Although the project did not fully go through, it became a valuable learning experience in project management, communication and advocacy.
        </p>
      </section>

      {/* ================= PROCESS ================= */}
      <section className="project-section reveal">
        <h2>Process</h2>

        <div className="columns-3">
          <div className="journey-card">
            <h3>Planning</h3>
            <p>We identified a need for free menstrual products on campus and defined the project's purpose, target group and potential impact.</p>
          </div>

          <div className="journey-card">
            <h3>Outreach & Partnerships</h3>
            <p>Contacted companies to pitch the project and explore sponsorship opportunities, presenting our vision and expected social impact.</p>
          </div>

          <div className="journey-card">
            <h3>Reflection</h3>
            <p>Although the project did not move forward, it provided valuable insights into advocacy work, communication and initiative-taking.</p>
          </div>
        </div>
      </section>
    </main>
  );
}
